type Accent = "primary" | "accent" | "secondary" | "neutral";

const ACCENT_STYLES: Record<Accent, string> = {
  primary: "bg-primary-100 text-primary-700",
  accent: "bg-accent-100 text-accent-900",
  secondary: "bg-secondary-100 text-secondary-900",
  neutral: "bg-background-200 text-foreground-600",
};

interface StatCardProps {
  label: string;
  value: string;
  icon: string;
  hint?: string;
  accent?: Accent;
}

export default function StatCard({
  label,
  value,
  icon,
  hint,
  accent = "primary",
}: StatCardProps) {
  return (
    <div className="bg-background-50 rounded-card border border-background-200/70 shadow-card p-3.5 md:p-5 flex items-start justify-between gap-2 md:gap-3 animate-fade-slide-up">
      <div className="min-w-0">
        <p className="text-xs md:text-sm text-foreground-500 leading-snug">{label}</p>
        <p className="mt-1.5 md:mt-2 text-2xl md:text-3xl font-bold text-foreground-900 tracking-tight" dir="ltr">
          {value}
        </p>
        {hint ? <p className="mt-1 md:mt-1.5 text-[11px] md:text-xs text-foreground-400 leading-snug">{hint}</p> : null}
      </div>
      <div className={`w-10 h-10 md:w-12 md:h-12 rounded-btn flex items-center justify-center shrink-0 ${ACCENT_STYLES[accent]}`}>
        <i className={`${icon} text-xl md:text-2xl`}></i>
      </div>
    </div>
  );
}